import React from "react";
import { Stack } from "@mui/material";
import { useSearchParams } from "react-router-dom";

import { SideNavBarV2 } from "../../components";
import { sidetabs } from "./helper";
import { StyledShell } from "./styles";

const UserProfilePageContent = () => {
  const [params, setParams] = useSearchParams();
  const param = params.get("tab");
  const known = sidetabs.find((t) => t.id === param);
  const tab = known?.id || sidetabs[0].id;
  const Active = sidetabs.find((t) => t.id === tab)?.Component;

  const onSetTab = (id) => {
    const next = new URLSearchParams(params);
    next.set("tab", id);
    setParams(next, { replace: true });
  };

  return (
    <Stack direction="row" width="100%" height="100%" overflow="hidden">
      <SideNavBarV2 tabs={sidetabs} value={tab} setValue={onSetTab} />
      <StyledShell>{Active && <Active />}</StyledShell>
    </Stack>
  );
};

export default UserProfilePageContent;
